import { InjectionToken } from '@angular/core';

import { AuthSession } from './session.types';

export const AUTH_SESSION = new InjectionToken<AuthSession>('AUTH_SESSION');
